module.exports = __webpack_public_path__ + "static/img/view.11bd6ba5.svg";